<div class="p-4">
  <table mat-table [dataSource]="dataSource" matSort>
    <!-- Name Column -->
    <ng-container matColumnDef="countryName">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element" data-label="Name">
        {{ element.countryName }}
      </td>
    </ng-container>

    <!-- Code Column -->
    <ng-container matColumnDef="countryCode">
      <th mat-header-cell *matHeaderCellDef>Code</th>
      <td mat-cell *matCellDef="let element" data-label="Code">
        {{ element.countryCode }}
      </td>
    </ng-container>

    <!-- Currency Column -->
    <ng-container matColumnDef="currencySupported">
      <th mat-header-cell *matHeaderCellDef>Currency</th>
      <td mat-cell *matCellDef="let element" data-label="Currency">
        {{ element.currencySupported[0].currency }}
      </td>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <ng-container *appHasAccess="'/settings/edit-source-country'">
          Action
        </ng-container>
      </th>
      <td mat-cell *matCellDef="let element" data-label="Action">
        <div class="d-flex align-items-center action-gap-10">
          <img
            src="assets/images/edit-icon.svg"
            alt="edit-icon"
            matTooltip="Edit"
            matTooltipPosition="left"
            [attr.aria-hidden]="true"
            (click)="onEdit(element)"
            *appHasAccess="'/settings/edit-source-country'" />
          <img
            src="assets/images/delete-icon.svg"
            alt="delete-icon"
            matTooltip="Delete"
            matTooltipPosition="right"
            [attr.aria-hidden]="true"
            (click)="onDeleteSourceCountry(element)"
            *appHasAccess="'delete-source-country'" />
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      class="custom-mat-btn"
      *matRowDef="let row; columns: displayedColumns; let element"></tr>
  </table>
</div>
